import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VenuesVideo.css';

const VIDEO_ID = 'Vwle9lfwsgs';

const VenuesVideo = () => {
  const { t } = useTranslation();
  const [playing, setPlaying] = useState(false);

  return (
    <section id="video" className="tk-video-section">
      <div className="tk-video-inner">
        <h2 className="tk-video-title">{t('venues.video.title')}</h2>
        <p className="tk-video-subtitle">{t('venues.video.subtitle')}</p>
        <div className="tk-video-frame">
          {playing ? (
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
              title={t('venues.video.title')}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <button type="button" className="tk-video-poster" onClick={() => setPlaying(true)} aria-label={t('venues.video.play')}>
              <img src="/img/venues-tutorial.jpg" alt="" loading="lazy" />
              <span className="tk-video-play" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z" /></svg>
              </span>
              <span className="tk-video-duration">{t('venues.video.duration')}</span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default VenuesVideo;
